<template>
  <data-cell-edit-dialog v-bind="$attrs">
    <template #cell="{ props }">
      <data-cell-text v-bind="props" />
    </template>
    <template #control="{ props, setValue }">
      <bm-number-q data-qa="number" v-bind="props" @update:value="setValue" />
    </template>
  </data-cell-edit-dialog>
</template>

<script lang="ts">
export default {
  name: "DataCellNumberEdit",
  inheritAttrs: false,
};
</script>

<script lang="ts" setup>
import DataCellEditDialog from "@/components/controls/grid/renderers/editors/DataCellEditDialog.vue";
import DataCellText from "@/components/controls/grid/renderers/DataCellText.vue";
import BmNumberQ from "@/components/controls/input/BmNumberQ.vue";
</script>
